import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '..'

export interface User {
  automator?: boolean
  createdBy?: string | null
  displayName: string
  email: string
  id: string
  isActive: boolean
  language: string
  lastModifiedBy?: string
  oid?: string
  uiFlags?: number
  rolePermissions?: string[]
  roleName?: string
  role?: string
}

export interface UserState {
  users?: User[]
  selected?: User
  currentUser?: User
  listCsv?: string
  detailsCsv?: string
}

const initialState: UserState = {
  users: [],
  selected: undefined,
  currentUser: undefined,
  listCsv: undefined,
  detailsCsv: undefined,
}

const userSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    setUsers: (state, action: PayloadAction<User[]>) => {
      state.users = action.payload
    },
    setSelectedUser: (state, action: PayloadAction<User>) => {
      state.selected = action.payload
    },
    setCurrentUser: (state, action: PayloadAction<User>) => {
      state.currentUser = action.payload
    },
    setUserListCsv: (state, action: PayloadAction<string>) => {
      state.listCsv = action.payload
    },
    setUserDetailsCsv: (state, action: PayloadAction<string>) => {
      state.detailsCsv = action.payload
    },
    clearUserState: () => initialState,
  },
})

export const {
  clearUserState,
  setCurrentUser,
  setSelectedUser,
  setUserDetailsCsv,
  setUserListCsv,
  setUsers,
} = userSlice.actions

export const getUsers = (state: RootState) => state.user.users

const userReducer = userSlice.reducer
export default userReducer
